import { commentsData } from '@/mocks/homepage';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">吃瓜热评</h2>
          <p className="text-sm text-foreground-500 mt-2">看看大家都在讨论什么</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {commentsData.map((comment) => (
            <div key={comment.id} className="bg-background-50 rounded-2xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex-shrink-0 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-sm font-heading font-bold text-primary-700">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground-800">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200">
                <span className="text-xs text-foreground-400 flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i>{comment.likes}
                </span>
                <span className="text-xs text-foreground-400 flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i>回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}